import axiosClient from './axiosClient';
import { cachedRequest, invalidateRequest } from './requestCache';

const REWARDS_KEY = 'rewards:list';

export const redeemReward = async (itemIndex) => {
  try {
    const response = await axiosClient.post('v1/redeem-item', {
      item: itemIndex + 1, // Send item index + 1 in the body
    });
    return response;
  } catch (error) {
    throw error.response?.data || { success: false, errors: true, data: { message: 'An error occurred' } };
  }
};

export const completeRedemption = async (data) => {
  try {
    const response = await axiosClient.post('v1/redeem-claim', data);
    invalidateRequest(REWARDS_KEY);
    return response;
  } catch (error) {
    throw error.response?.data || { success: false, errors: true, data: { message: 'An error occurred' } };
  }
}

export const requestRedeemOtp = async (item) => {
  try {
    const response = await axiosClient.post('v1/redeem-otp', { item });
    return response;
  } catch (error) {
    throw error.response?.data || { success: false, errors: true, data: { message: 'An error occurred' } };
  }
}

export const callGameNow = async (data) => {
  try {
    const response = await axiosClient.post('v1/gamenow/notify', JSON.stringify(data));
    return response;
  } catch (error) {
    throw error.response?.data || { success: false, errors: true, data: { message: 'An error occurred' } };
  }
}

export const getRewardsList = async () => {
  try {
    return await cachedRequest(REWARDS_KEY, async () => {
      const response = await axiosClient.post('v1/rewards');

      if (
        response.data?.success &&
        Array.isArray(response.data?.items)
      ) {
        const normalized = response.data.items
          .map(item => ({
            ...item,
            credits: item.price?.credits,
            game: item.game,
          }))
          .sort((a, b) => a.position - b.position);

        return {
          ...response,
          data: normalized,
        };
      }

      return response;
    });
  } catch (error) {
    throw (
      error.response?.data || {
        success: false,
        errors: true,
        data: {
          message: 'An error occurred',
        },
      }
    );
  }
};